var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7954C18.7614 21.7954 21 19.5568 21 16.7954C21 14.034 18.7614 11.7954 16 11.7954C13.2386 11.7954 11 14.034 11 16.7954C11 19.5568 13.2386 21.7954 16 21.7954Z",
    stroke: "#8189A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17867 23.0566C4.62614 22.1049 4.20283 21.0838 3.91992 20.0203L6.01742 17.3953C5.99367 16.994 5.99367 16.5916 6.01742 16.1903L3.92117 13.5653C4.2036 12.5017 4.62604 11.4802 5.17742 10.5278L8.51617 10.1528C8.78279 9.85245 9.06704 9.5682 9.36742 9.30158L9.74242 5.96408C10.6935 5.41533 11.7132 4.9954 12.7749 4.71533L15.3999 6.81283C15.8012 6.78908 16.2036 6.78908 16.6049 6.81283L19.2299 4.71658C20.2936 4.99901 21.315 5.42145 22.2674 5.97283L22.6424 9.31158C22.9428 9.5782 23.2271 9.86245 23.4937 10.1628L26.8312 10.5378C27.3837 11.4895 27.807 12.5106 28.0899 13.5741L25.9924 16.1991C26.0162 16.6004 26.0162 17.0028 25.9924 17.4041L28.0887 20.0291C27.8082 21.0924 27.3879 22.1138 26.8387 23.0666L23.4999 23.4416C23.2333 23.742 22.9491 24.0262 22.6487 24.2928L22.2737 27.6303C21.322 28.1829 20.3009 28.6062 19.2374 28.8891L16.6124 26.7916C16.2111 26.8153 15.8087 26.8153 15.4074 26.7916L12.7824 28.8878C11.7191 28.6074 10.6977 28.187 9.74492 27.6378L9.36992 24.2991C9.06954 24.0325 8.78529 23.7482 8.51867 23.4478L5.17867 23.0566Z",
    stroke: "#8189A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.79541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconSvg);
export default __webpack_public_path__ + "static/media/SettingsIconSVG.c5e1d8e3ea882b01a550ef7e9a41d172.svg";
export { ForwardRef as ReactComponent };